export class HousingCosts {
    constructor(expenses: number, delivery: number, furniture: number, utilities: number) {
        this.expenses = expenses;
        this.delivery = delivery;
        this.furniture = furniture;
        this.utilities = utilities;
    }
    public expenses: number;
    public delivery: number;
    public furniture: number;
    public utilities: number;
}
